export default __webpack_public_path__ + "static/index-vector-51a52a1300f4caf4e55b3a20277e7a23.png";